

















import mixins from 'vue-typed-mixins';
import DataSetFormVue from './DataSetForm.vue';
import DataSetContentVue from './DataSetContent.vue';
import DataSetUtils, { DataSet, DataSetContent } from '@/utils/DataSetUtils';
import cloneDeep from 'lodash.clonedeep';

export default mixins().extend({
  components: {
    DataSetForm: DataSetFormVue,
    DataSetContent: DataSetContentVue,
  },

  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },

    contentEditable(): boolean {
      return this.pristine?.oversighttype?.id === this.item?.oversighttype?.id;
    },
  },

  data(): {
    item?: Partial<DataSet>;
    pristine?: Partial<DataSet>;
  } {
    return {
      item: undefined,
      pristine: undefined,
    };
  },

  async mounted() {
    try {
      if (this.id) {
        this.item = await DataSetUtils.api.dataset.get(this.id);
        this.pristine = cloneDeep(this.item);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async save() {
      if (this.item) {
        try {
          this.$alert.hide('save');
          this.item = await DataSetUtils.api.dataset.update(this.item);
          this.pristine = cloneDeep(this.item);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.item?.name],
            }),
          });
        } catch (error) {
          this.$alert.show('save', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },
  },
});
